import { render, staticRenderFns } from "./DisqualificationQuery.vue?vue&type=template&id=7be0fa47"
import script from "./DisqualificationQuery.vue?vue&type=script&lang=js"
export * from "./DisqualificationQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports